// Customizable Area Start
import React from "react";
import { withRouter } from "react-router-dom";
import {
  createTheme,
  ThemeProvider,
  responsiveFontSizes,
  Theme,
  createStyles,
  withStyles,
  styled,
} from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Sidebar from "./Sidebar.web";
import NavigationMenu from "./NavigationMenu.web";
import { HomeIcon, ChatBubbleIcon, ContactsIcon, SettingsIcon, EveryReelIcon, ChatBubbleLargeIcon, StarIcon, UserIcon, AiIcon } from "./assets";
import AppLayoutController, { Props } from "./AppLayoutController.web";
import { routes } from "../../../components/src/constansts";
import BaseModal from "./BaseModal";
import { AppLayoutModals } from "./enums";
import AfterSignup from "./AfterSignup.web";
import InviteFriends from "./InviteFriends.web";
import { PausedAccount } from "./PausedAccount.web";
import MobileNavMenu from "./MobileNavMenu.web";
import clsx from "clsx"
import NavigationMenuMobile from "./NavigationMenuMobile.web";
import { EverybrandLibrary } from "../../postcreation/src/EverybrandLibrary.web";
import { Dialog, DialogContent,  
  Box,
  MenuItem,
  Modal,
  Typography, } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import { AddRounded } from "@material-ui/icons";
export const configJSON = require("./config.js");

let theme = createTheme({
  palette: {
    primary: {
      main: "#FFC629",
      contrastText: "#000",
    },
    background: {
      default: "#F1F5F9",
    },
  },
});

theme = responsiveFontSizes(theme);

const styles = (theme: Theme) =>
  createStyles({
    root: {
      position: "relative",
      '@media(min-width: 960px)': {
        display: 'flex'
      }
      // height: "100%"
    },
    //necessary for content to be below app bar
    offset: theme.mixins.toolbar,
    content: {
      flex: 1,
      "@media (max-width: 1149px)": {
        paddingBottom: "calc(64px + env(safe-area-inset-bottom))",
      },
    },
    componentWrapper: {
      "@media (max-width: 1149px)": {
        marginBottom: "0px"
      },
      "@media (min-width: 1149px)": {
        margin: "0 24px 65px",
        marginLeft: "0px",
        marginRight: '0px',
        marginBottom: "0px"
      }
    },
    disabled: {
      position: "relative",
    
     height:"100%",
      opacity: 0.5,
      pointerEvents: "none",
      
    },
    menuLink: {
      display: "flex",
      flexDirection: "row", // icon + text side by side
      alignItems: "center", // vertically center icon + text
      gap: "10px",
      color: "#000",
      textDecoration: "none",
      width: "100%",
    },
    menuItemContent: {
      display: "flex",
      flexDirection: "column", // title above description
      justifyContent: "center", // vertically center text block relative to icon
      flex: 1,
      minWidth: 0, // important for wrapping
    },
    menuTitle: {
      fontSize: "15px",
      fontFamily: "Inter, 'sans-serif'",
      fontWeight: 700,
      margin: 0,
    },
    menuDescription: {
      fontSize: "11px",
      fontFamily: "Inter, 'sans-serif'",
      fontWeight: 400,
      lineHeight: "18px",
      whiteSpace: "normal", // wrap text
      wordBreak: "break-word",
      color: "#555",
      margin: 0,
    },
    menuIconContainer: {
      display: "flex",
      // alignItems: "center",
      justifyContent: "center", // center icon inside box
      width: "24px",
      height: "24px",
      minWidth: "24px",
      "& img": {
        objectFit: "cover"
      },
      "& #every_reel": {
        height: "20px",
        width: "20px"
      },
      "& #chat, #star": {
        height: "21px",
        width: "21px"
      },
      "& #user": {
        height: "19px",
        width: "19px"
      },
    },

  });

const CustomDiloag = styled(Dialog)(({theme}) => ({
  "& .MuiDialog-paperFullWidth":{
    borderRadius: "8px 8px 32px 8px"
  },
  [theme.breakpoints.down(650)]: {
    "& .MuiDialog-paper": {
      margin: "0px",
    },
    "& .MuiDialog-paperFullWidth": {
      width: "calc(100% - 24px)",
    },
  },
  "& .MuiDialogContent-root":{
    padding: "20px 12px 20px"
  }
}))

const AfterSignupDialog = styled(Dialog)((({theme}) => ({
  "& .MuiDialogContent-root":{
    padding: "20px 12px 20px"
  },
  "& .MuiDialog-paperScrollPaper":{
    borderRadius: "8px 8px 32px 8px",
    [theme.breakpoints.down(768)]: {
      maxHeight: "calc(100% - 24px)",
    },
  },
  "& .MuiDialog-paper":{
    maxWidth: "90%",
    [theme.breakpoints.down(768)]: {
      margin: "12px",
    },
  },
  "& .MuiDialog-paperWidthSm":{
    maxWidth: "900px"
  }
})));

const navigationMenus = [
  { name: "home", icon: HomeIcon, path: routes.dashboard },
  { name: "Messages", icon: ChatBubbleIcon, path: routes.messages },
  { name: "Contacts", icon: ContactsIcon, path: routes.contacts },
  { name: "Brando", icon: AiIcon, path: routes.automations },
];

class AppLayout extends AppLayoutController {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const { location } = this.props;
    const pathname: string = location?.pathname || "";
    const subscriptionStatus = localStorage.getItem("subscriptionStatus") === "true";
  
   const isSettingsRoute = pathname !== '/settings/true';

    const {
      selectedWebsite,
      websitesList,
      isMobileDrawerOpen,
      currentUserInfo,
      showModal,
      openLogoutModal,
     
    } = this.state;
  
    const { children, classes,...otherprops } = this.props;
    const socialPhoneNumber = currentUserInfo?.attributes?.social_phone_number || "";


    return (
      <ThemeProvider theme={theme} >
        <div className={classes.root}>
          <div className={subscriptionStatus ? classes.disabled : ""}>
          <CssBaseline />
          {!((pathname.includes("/settings") || pathname.includes("/VisualAnalytics") || pathname.includes("/messages")) && window.innerWidth < 950) ? <NavigationMenu
            navigationMenus={navigationMenus}
            selectedWebsite={selectedWebsite}
            websitesList={websitesList}
            currentUserInfo = {currentUserInfo}
            onWebsiteSelect={this.handleWebsiteSelection}
            onDrawerToggle={this.handleDrawerToggle}
          /> : <NavigationMenuMobile 
                  backButton={this.state.backArrowFunction}
                  name={this.state.mobileNavigationName}
                  icon={this.state.mobileNavigationIcon}
                  dropdownButton={this.state.dropdownFunction}>
          </NavigationMenuMobile>}
        {this.state.showSidebar &&
        <Sidebar
            businessUserInfo={currentUserInfo}
            isMobileDrawerOpen={isMobileDrawerOpen}
            onCloseDrawer={this.handleDrawerToggle}
            onLogout={this.logoutAndRedirectToLogin}
            logoutModal={this.openLogoutModal}
            logoutModalState={openLogoutModal}
            openModal={this.openModal}
        />}
      </div>
        <main className={classes.content}>
          <div className={classes.offset} />
          {React.Children.map(children, (child:any) => {
            return (
              <>           
                {subscriptionStatus && isSettingsRoute && (<PausedAccount classes={{}} navigation={undefined} id={""} banUserApiCall={()=>{} } postCommentApiCall={()=>{} }/>)}
                <div className={clsx(classes.componentWrapper, { [classes.disabled]: subscriptionStatus && isSettingsRoute })}>
                  {React.cloneElement(child, { ...otherprops })}
                </div>
              </>
            );
          })}

        </main>
          {showModal && showModal === AppLayoutModals.INVITE_FRIENDS && (
            <BaseModal closeModal={this.closeModal} modalData={{ socialPhoneNumber }}>
              {showModal === AppLayoutModals.INVITE_FRIENDS &&
                <InviteFriends closeModal={this.closeModal} />
              }
            </BaseModal>
          )}
          {
            <>
              {showModal === AppLayoutModals.AFTER_SIGNUP_WELCOME &&
                <AfterSignupDialog open onClose={this.closeModal}>
                  <AfterSignup closeModal={this.closeModal} socialPhoneNumber={socialPhoneNumber} />
                </AfterSignupDialog>
              }
            </>
          }
          {showModal && showModal === AppLayoutModals.EVERYREEL_LIBRARY && ( 
            <>
              <CssBaseline />
              <CustomDiloag
                open
                fullWidth
                maxWidth="md"
                onClose={(_event, reason) => {
                  // Opening the native file picker (video upload) from inside this modal
                  // makes the browser register a spurious backdrop click when focus
                  // returns, which would otherwise close this dialog mid-upload.
                  if (reason === "backdropClick") {
                    return;
                  }
                  this.closeModal();
                }}
              >
                <DialogContent>
                  <EverybrandLibrary goBack={() => {this.closeModal()}} setFiles={() => {}}/>
                </DialogContent>
              </CustomDiloag>
            </>
            )
          }
        </div>
        <MobileNavMenu navigation={this.props.navigation} openModal={this.openModalPost} />
        {this.state.setOpenPostModal && (
  <Modal open onClose={this.closeModalPost}>
<Box
  style={{
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '16px',
    maxWidth: '500px', // fix max width
    width: '90%', // responsive
    maxHeight: '80vh', // responsive height
    overflowY: 'auto',
    boxSizing: 'border-box',
  }}
>

            <MenuItem
              data-test-id="newPostMenuItem"
              className={classes.menuItem}
              // onClick={() => {
              //   setQuickAccessAnchorEl(null);
              // }}
            >
              <NavLink className={classes.menuLink} to="/NewPost">
                <Box
                  className={classes.menuIconContainer}
                  style={{ width: "10px", height: "10px" }}
                >
                  <AddRounded />
                </Box>
                <Box className={classes.menuItemContent}>
                  <Typography className={classes.menuTitle}>Post</Typography>
                  <Typography className={classes.menuDescription}>
                    {configJSON.menuPostsDescription}
                  </Typography>
                </Box>
              </NavLink>
            </MenuItem>

            <MenuItem
              data-test-id="newEveryreelMenuItem"
              className={classes.menuItem}
              onClick={() => {
                // setQuickAccessAnchorEl(null);
              }}
            >
              <NavLink className={classes.menuLink} to="/CreateEveryreel">
                <Box className={classes.menuIconContainer}>
                  <img id="every_reel" src={EveryReelIcon} alt="menu icon" />
                </Box>
                <Box className={classes.menuItemContent}>
                  <Typography className={classes.menuTitle}>
                    Brandly
                  </Typography>
                  <Typography className={classes.menuDescription}>
                    {configJSON.menuEveryreelDescription}
                  </Typography>
                </Box>
              </NavLink>
            </MenuItem>

            <MenuItem
              data-test-id="newMessageMenuItem"
              className={classes.menuItem}
              onClick={() => {
                // setQuickAccessAnchorEl(null);
              }}
            >
              <NavLink className={classes.menuLink} to="/messages?new-chat=true">
                <Box className={classes.menuIconContainer}>
                  <img id="chat" src={ChatBubbleLargeIcon} alt="menu icon" />
                </Box>
                <Box className={classes.menuItemContent}>
                  <Typography className={classes.menuTitle}>Message</Typography>
                  <Typography className={classes.menuDescription}>
                    {configJSON.menuMessageDescription}
                  </Typography>
                </Box>
              </NavLink>
            </MenuItem>

            <MenuItem
              data-test-id="newContactMenuItem"
              className={classes.menuItem}
              // onClick={() => setQuickAccessAnchorEl(null)}
            >
              <NavLink className={classes.menuLink} to="/contacts/add">
                <Box className={classes.menuIconContainer}>
                  <img id="user" src={UserIcon} alt="menu icon" />
                </Box>
                <Box className={classes.menuItemContent}>
                  <Typography className={classes.menuTitle}>Contact</Typography>
                  <Typography className={classes.menuDescription}>
                    {configJSON.menuContactDescription}
                  </Typography>
                </Box>
              </NavLink>
            </MenuItem>

            <MenuItem
              data-test-id="newReviewMenuItem"
              className={classes.menuItem}
              // onClick={() => setQuickAccessAnchorEl(null)}
            >
              <NavLink className={classes.menuLink} to="/ReviewInvite">
                <Box className={classes.menuIconContainer}>
                  <img id="star" src={StarIcon} alt="menu icon" />
                </Box>
                <Box className={classes.menuItemContent}>
                  <Typography className={classes.menuTitle}>Review</Typography>
                  <Typography className={classes.menuDescription}>
                    {configJSON.menuReviewDescription}
                  </Typography>
                </Box>
              </NavLink>
            </MenuItem>
    </Box>
  </Modal>
)}


      </ThemeProvider>
    );
  }
}

export { AppLayout };
export default withStyles(styles)(withRouter(AppLayout));
// Customizable Area End
